import { useEffect, useState } from "react";
import axios from "axios";
import "./wanted.css";  // 👈 our new styling

function Wanted() {
  const [todos, setTodos] = useState([]);
  const [task, setTask] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [locked, setLocked] = useState(true);

  const API_URL = "https://gamecollection-app.onrender.com/api/todos";
    const API_URL_SHORT = "https://gamecollection-app.onrender.com/api";

  const sendUnlock = async (password) => {
    try {
      const response = await axios.post(`${API_URL_SHORT}/unlock`, { password });
      if (response.data.unlocked) {
        setLocked(false);
        sessionStorage.setItem("myToken", response.data.token);
      }
    } catch {
      console.log("password check failed");
    }
  };

  useEffect(() => {
    sendUnlock(sessionStorage.getItem("myToken"));
    fetchTodos();
  }, []);

  const fetchTodos = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_URL);
      setTodos(res.data);
      setError("");
    } catch {
      setError("Failed to fetch todos 😢");
    } finally {
      setLoading(false);
    }
  };

  const addTodo = async (e) => {
    e.preventDefault();
    if (!task.trim()) return;
    try {
      await axios.post(API_URL, { task });
      setTask("");
      fetchTodos();
    } catch {
      setError("Failed to add todo");
    }
  };

  const toggleTodo = async (id, completed) => {
    if (locked){
      return false;
    }
    try {
      await axios.put(`${API_URL}/${id}`, { completed: !completed });
      fetchTodos();
    } catch {
      setError("Failed to update todo");
    }
  };

  const deleteTodo = async (id) => {
    try {
      await axios.delete(`${API_URL}/${id}`);
      fetchTodos();
    } catch {
      setError("Failed to delete todo");
    }
  };

  return (
    <div className="wanted-container">
      <h1>Shopping List</h1>

      {!locked && (
        <form onSubmit={addTodo} className="wanted-form">
          <input
            type="text"
            placeholder="Enter a task..."
            value={task}
            onChange={(e) => setTask(e.target.value)}
          />
          <button type="submit">➕</button>
        </form>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : (
        <ul className="wanted-list">
          {todos.map((todo) => (
            <li key={todo.id} className={todo.completed ? "done" : ""}>
              <span onClick={() => toggleTodo(todo.id, todo.completed)}>
                {todo.task}
              </span>
              {!locked && (
                <button onClick={() => deleteTodo(todo.id)}>❌</button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Wanted;
